// Titles of the backend todo contributors' domains, as the ToDo page groups them.
export const DOMAIN_TITLE = {
  expenses:      'Utlägg',
  time_reports:  'Tidrapporter',
  tax_reporting: 'Skatt & moms',
  agent:         'AI-assistenten',
  banking:       'Bank & Skatt',
  payments:      'Betalningar',
  periodisering: 'Periodiseringar',
};
